import { ExportType, GlobalPeriodSelect } from '@components'

import { Button, Text } from '@billy/design-system'
import { useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'

import { useDownloadExportFile } from '@features/exports/hooks/useDownloadExportFile'
import { useUserOrganization } from '@modules-deprecated/app/organization'

import { PeriodMode } from '../../../../enums/periodMode'
import { useSegment } from '../../../../hooks'
import { useOrganizationFiscalYears } from '../../../../hooks/useOrganizationFiscalYears'
import { PeriodValue } from '../../../../types/periodValue'
import { useExportsPeriodValue } from '../../hooks/useExportsPeriodValue'
import { ExportsCard } from '../ExportsCard'

const XAF_EXPORT_URL = 'xafExport'

export const XafExport = () => {
  const { t } = useTranslation()
  const { organization } = useUserOrganization()
  const { encodedPeriodValue, period, setPeriod } = useExportsPeriodValue()
  const { downloadExportFile } = useDownloadExportFile()
  const { defaultYear } = useOrganizationFiscalYears()
  const { track } = useSegment()

  const organizationId = organization?.id

  useEffect(() => {
    setPeriod({
      mode: PeriodMode.FiscalYear,
      value: defaultYear,
      year: defaultYear,
    })
  }, [defaultYear, setPeriod])

  const handleClickExport = useCallback(() => {
    if (!organizationId) {
      return
    }

    downloadExportFile({
      exportUrl: XAF_EXPORT_URL,
      type: ExportType.Xaf,
      queryParams: {
        period: encodedPeriodValue,
      },
    })

    track('XXX - Mikkel - Exports', {
      // eslint-disable-next-line @typescript-eslint/naming-convention
      export_type: 'Audit file',
      period: period.value,
    })
  }, [downloadExportFile, encodedPeriodValue, organizationId, period.value, track])

  const handleChangePeriod = useCallback(
    (newPeriod: PeriodValue) => {
      setPeriod(newPeriod)
    },
    [setPeriod],
  )

  return (
    <ExportsCard
      description={t('exports.card.xaf_export.description')}
      title={t('exports.card.xaf_export.title')}
      actionButton={
        <Button onClick={handleClickExport} fullWidth variant="outlined">
          {t('exports.card.xaf_export.button.label')}
        </Button>
      }
    >
      <div>
        <Text colorVariant="label" weight="medium">
          {t('exports.period')}
        </Text>
        <GlobalPeriodSelect
          disabledPeriodModes={[
            PeriodMode.All,
            PeriodMode.CustomDate,
            PeriodMode.CustomDateFrom,
            PeriodMode.CustomDateThrough,
            PeriodMode.Month,
            PeriodMode.Quarter,
          ]}
          encodedPeriod={encodedPeriodValue}
          onChange={handleChangePeriod}
          fullWidth
        />
      </div>
    </ExportsCard>
  )
}
